export type Theme = "light" | "dark" | "system";
export type ResolvedTheme = Exclude<Theme, "system">;

export const THEME_STORAGE_KEY = "tmw-theme";

export function isTheme(value: unknown): value is Theme {
  return value === "light" || value === "dark" || value === "system";
}

// Runs before the page paints. Only a fixed set of values can reach the DOM.
export const themeInitScript = `(()=>{let t="system";try{const v=localStorage.getItem("${THEME_STORAGE_KEY}");if(v==="light"||v==="dark"||v==="system")t=v}catch{}const r=t==="system"?(matchMedia("(prefers-color-scheme: dark)").matches?"dark":"light"):t;const e=document.documentElement;e.classList.remove("light","dark");e.classList.add(r);e.dataset.theme=r;e.style.colorScheme=r;const m=document.querySelector('meta[name="theme-color"]');if(m)m.content=r==="dark"?"#09090b":"#f9faf6"})()`;
